import{ Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button} from "@mui/material"

export default function AddCommentDialog({open, onClose, onSave, comment, setComment}){
    return(
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Add Comments</DialogTitle>
            <DialogContent>
                <TextField
                 label="Comments"
                 fullWidth
                 margin="normal"
                 multiline
                 rows={4}
                 inputProps={{maxLength: 1000}}
                 value={comment}
                 onChange={(e)=>setComment(e.target.value)}
                 />
            </DialogContent>
            <DialogActions sx={{justifyContent: "flex-end", pr: 3, pb: 2}}>
                <Button onClick={onClose} color="inherit">Cancel</Button>
                <Button
                    onClick={onSave}
                    variant="contained"
                    color="primary"
                    sx={{
                        '&:hover': {
                            backgroundColor: (theme) => theme.palette.primary.main
                        }
                    }}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}